import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LoadingCircleComponent } from './loading-circle.component';


@NgModule({
  declarations: [LoadingCircleComponent],
  exports: [LoadingCircleComponent],
  imports: [
    CommonModule,
  ]
})
export class LoadingCircleModule { }
